var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Error",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M41.71,43.48a1.68,1.68,0,0,1-1-.3,3.65,3.65,0,0,1-.49-.42L32,34.5l-8.34,8.34a1.87,1.87,0,0,1-1.34.63,2,2,0,0,1-.45-.05,1.73,1.73,0,0,1-1.23-1.07,1.7,1.7,0,0,1,.18-1.61,3.62,3.62,0,0,1,.42-.49L29.5,32l-8.25-8.25a1.88,1.88,0,0,1-.68-1.82,1.75,1.75,0,0,1,1.73-1.42,1.72,1.72,0,0,1,1.13.42c.1.08.18.17.27.26L32,29.5l8.25-8.25a2,2,0,0,1,1.45-.72,1.94,1.94,0,0,1,.37,0,1.75,1.75,0,0,1,1,2.86c-.09.1-.18.19-.27.28L34.5,32l1.89,1.89,6.46,6.46a1.8,1.8,0,0,1,.58,1.79,1.76,1.76,0,0,1-1.71,1.35Z"/>
    <path d="M22.29,21a1.23,1.23,0,0,1,.81.3l.25.24.07.07L31,29.18l.32.32.71.71.71-.71,1.86-1.86,6-6A1.5,1.5,0,0,1,41.7,21l.27,0a1.25,1.25,0,0,1,.71,2l-.25.26-.07.07-5.74,5.74L34.5,31.3l-.71.71.71.71,1.68,1.69,6.31,6.3A1.29,1.29,0,0,1,42.93,42a1.25,1.25,0,0,1-1.22,1,1.17,1.17,0,0,1-.68-.21,3.18,3.18,0,0,1-.43-.37L32.7,34.5,32,33.8l-.71.71-1.56,1.55L23.3,42.49a1.34,1.34,0,0,1-1,.48,1.52,1.52,0,0,1-.33,0,1.24,1.24,0,0,1-.74-1.9,3.18,3.18,0,0,1,.37-.43l7.89-7.9.71-.71-.71-.71-1.81-1.81L21.6,23.4A1.39,1.39,0,0,1,21.06,22a1.25,1.25,0,0,1,1.24-1h0m0-1a2.25,2.25,0,0,0-2.22,1.82,2.4,2.4,0,0,0,.82,2.27L28.79,32l-7.9,7.9a4.18,4.18,0,0,0-.48.56,2.24,2.24,0,0,0,1.34,3.45,2.5,2.5,0,0,0,.56.07A2.35,2.35,0,0,0,24,43.2l8-8,7.9,7.89a4.18,4.18,0,0,0,.56.48,2.18,2.18,0,0,0,1.25.39,2.25,2.25,0,0,0,2.2-1.74A2.29,2.29,0,0,0,43.19,40l-8-8,7.87-7.87c.12-.12.25-.24.36-.38a2.25,2.25,0,0,0-1.28-3.68,2.39,2.39,0,0,0-.46,0,2.52,2.52,0,0,0-1.8.87L32,28.8l-7.87-7.87c-.12-.12-.24-.25-.38-.36A2.22,2.22,0,0,0,22.29,20Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/error.svg